import React, { memo } from 'react';
import withErrorBoundary from '../hoc/withErrorBoundary';

export default  (Component) => memo(withErrorBoundary(Component));
